/* assets/alb-kostenrechner.js · ALB Horizon Rebuild
   Kostenrechner „Wasserfilter oder Flaschenwasser“: Haushalt (Personen × Liter je Tag), Flaschenpreis je Liter
   (Vorgaben aus den Section-Settings oder eigener Wert) und ein Alb Filter (Blöcke mit Set, Kartusche, Intervall,
   Kapazität, Live-Preise aus Liquid; Fusion-Systeme mit zweiter Kartusche und eigenem Intervall). Ausgabe: Kosten im ersten Jahr und ab dem zweiten Jahr, Ersparnis in Euro,
   getragene Kilo und Preis je Liter. Keine Umweltaussagen, keine Rundungstricks: Ist Flaschenwasser günstiger,
   steht das so da. Alles läuft im Browser; GA4 bekommt nur grobe Kennwerte, erst nach Analyse-Einwilligung. */
(function () {
  'use strict';
  if (customElements.get('alb-kostenrechner')) return;

  var GA4_ID = 'G-BKZBE7XSL1';

  function albGa4(eventName, params) {
    var p = { send_to: GA4_ID };
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k) && params[k] !== undefined && params[k] !== '') p[k] = params[k];
    }
    if (typeof window.gtag === 'function') { window.gtag('event', eventName, p); return; }
    window.dataLayer = window.dataLayer || [];
    (function () { window.dataLayer.push(arguments); })('event', eventName, p);
  }

  function mitAnalyseEinwilligung(los) {
    var S = window.Shopify;
    var pruefen = function () {
      var cp = S && S.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) { los(); return; }
      var beiEntscheidung = function (e) {
        if (!(e && e.detail && e.detail.analyticsAllowed)) return;
        document.removeEventListener('visitorConsentCollected', beiEntscheidung);
        los();
      };
      document.addEventListener('visitorConsentCollected', beiEntscheidung);
    };
    if (S && S.customerPrivacy) { pruefen(); return; }
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { pruefen(); });
      return;
    }
    pruefen();
  }

  function euro(x) { return Number(x).toLocaleString('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }); }
  function euroCent(x) { return Number(x).toLocaleString('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function zahl(x, st) { return Number(x).toLocaleString('de-DE', { maximumFractionDigits: st === undefined ? 0 : st }); }
  function esc(t) { var d = document.createElement('div'); d.textContent = String(t == null ? '' : t); return d.innerHTML; }

  var warteschlange = [], einwilligungAngefragt = false, einwilligungErteilt = false, gezaehlt = false;

  class AlbKostenrechner extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      try { this.texte = JSON.parse(this.querySelector('script[data-texte]').textContent); } catch (e) { this.texte = {}; }
      try { this.filter = JSON.parse(this.querySelector('script[data-filter]').textContent); } catch (e) { this.filter = []; }
      this.personen = this.querySelector('[data-personen]');
      this.liter = this.querySelector('[data-liter]');
      this.preisFeld = this.querySelector('[data-preis]');
      this.preisChips = this.querySelectorAll('[data-preis-chip]');
      this.flasche = this.querySelector('[data-flasche]');
      this.filterChips = this.querySelectorAll('[data-filter-chip]');
      this.abo = this.querySelector('[data-abo]');
      this.ergebnis = this.querySelector('[data-ergebnis]');
      if (!this.ergebnis || !this.filter.length) return;
      var self = this;
      var neu = function () { self.rechne(); };
      ['input', 'change'].forEach(function (ev) {
        if (self.personen) self.personen.addEventListener(ev, neu);
        if (self.liter) self.liter.addEventListener(ev, neu);
        if (self.preisFeld) self.preisFeld.addEventListener(ev, function () { self.setzeChip(null); neu(); });
        if (self.flasche) self.flasche.addEventListener(ev, neu);
        if (self.abo) self.abo.addEventListener(ev, neu);
      });
      this.preisChips.forEach(function (c) {
        c.addEventListener('click', function () {
          if (self.preisFeld) self.preisFeld.value = String(c.getAttribute('data-preis-chip')).replace('.', ',');
          self.setzeChip(c); neu();
        });
      });
      this.filterChips.forEach(function (c) {
        c.addEventListener('click', function () {
          self.filterChips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          neu();
        });
      });
      this.querySelectorAll('[data-wert]').forEach(function (out) {
        var src = self.querySelector('[data-' + out.getAttribute('data-wert') + ']');
        if (src) src.addEventListener('input', function () { out.textContent = src.value.replace('.', ','); });
      });
      this.rechne();
    }

    setzeChip(aktiv) {
      this.preisChips.forEach(function (c) { c.setAttribute('aria-pressed', c === aktiv ? 'true' : 'false'); });
    }

    aktiverFilter() {
      var idx = 0;
      this.filterChips.forEach(function (c, i) {
        if (c.getAttribute('aria-pressed') !== 'true') return;
        var n = parseInt(c.getAttribute('data-filter-chip'), 10);   // Index in der Filterliste (Chips sind nach Gruppen sortiert)
        idx = isNaN(n) ? i : n;
      });
      return this.filter[idx] || this.filter[0];
    }

    rechne() {
      var t = this.texte;
      var personen = Math.max(1, parseInt(this.personen ? this.personen.value : '2', 10) || 1);
      var literProKopf = Math.max(0.1, parseFloat(String(this.liter ? this.liter.value : '1.5').replace(',', '.')) || 1.5);
      var preisL = Math.max(0, parseFloat(String(this.preisFeld ? this.preisFeld.value : '0.24').replace(',', '.')) || 0);
      var glas = this.flasche && this.flasche.value === 'glas';
      var mitAbo = !!(this.abo && this.abo.checked);
      var f = this.aktiverFilter();

      var literJahr = personen * literProKopf * 365;
      var flaschenJahr = literJahr * preisL;
      // Getragene Kilo: Wasser 1 kg je Liter; Glas-Mehrweg wiegt je Liter Inhalt rund 0,85 kg mehr (Leergut hin und zurück)
      var kiloJahr = literJahr * (glas ? 1.85 : 1.03);

      // Kartuschen je Jahr: Zeit (Intervall) oder Kapazität, was zuerst greift. Fusion-Systeme bringen zwei Kartuschen mit.
      var karts = [{ titel: f.kartusche_titel, preis: f.kartusche_preis, intervall: f.intervall, kap: f.kapazitaet, imSet: f.kartuschen_im_set, abo: f.abo_pct }];
      if (f.kartusche2_preis > 0) karts.push({ titel: f.kartusche2_titel, preis: f.kartusche2_preis, intervall: f.intervall2, kap: f.kapazitaet2, imSet: f.kartuschen2_im_set, abo: f.abo2_pct });
      var laufend = 0, jahr1 = f.set_preis, aboAktiv = false;
      karts.forEach(function (k) {
        k.n = Math.max(12 / (k.intervall || 4), k.kap ? literJahr / k.kap : 0);
        k.p = k.preis * (mitAbo && k.abo ? (1 - k.abo / 100) : 1);
        if (mitAbo && k.abo) aboAktiv = true;
        laufend += k.n * k.p;
        jahr1 += Math.max(0, k.n - (k.imSet || 1)) * k.p;
      });
      var kartuschenJahr = karts[0].n, kPreis = karts[0].p;
      var abJahr2 = laufend;
      var fuenf = jahr1 + 4 * abJahr2;
      var flaschenFuenf = flaschenJahr * 5;
      var literpreisFilter = literJahr ? abJahr2 / literJahr : 0;
      var diffJahr1 = flaschenJahr - jahr1, diffAb2 = flaschenJahr - abJahr2, diffFuenf = flaschenFuenf - fuenf;

      var fazit;
      if (diffFuenf > 0) {
        fazit = (t.fazit_filter || 'Über fünf Jahre kann der {filter} rund {betrag} günstiger sein als Flaschenwasser.')
          .replace('{filter}', esc(f.titel)).replace('{betrag}', euro(diffFuenf));
      } else {
        fazit = (t.fazit_flasche || 'Bei diesen Angaben ist Flaschenwasser über fünf Jahre rund {betrag} günstiger. Der Filter rechnet sich dann über Geschmack, Komfort und weniger Schleppen, nicht über den Preis.')
          .replace('{betrag}', euro(-diffFuenf));
      }

      var aboText = aboAktiv ? (t.detail_abo || ' im Spar-Abo') : '';
      var detailText;
      if (karts.length > 1) {
        detailText = (t.detail_zwei || '{liter} Liter im Jahr. {kartuschen1} × {titel1} zu je {kpreis1} und {kartuschen2} × {titel2} zu je {kpreis2}{abo}.')
          .replace('{liter}', zahl(literJahr))
          .replace('{kartuschen1}', zahl(karts[0].n, 1)).replace('{titel1}', karts[0].titel || 'Kartusche').replace('{kpreis1}', euroCent(karts[0].p))
          .replace('{kartuschen2}', zahl(karts[1].n, 1)).replace('{titel2}', karts[1].titel || 'Kartusche').replace('{kpreis2}', euroCent(karts[1].p))
          .replace('{abo}', aboText);
      } else {
        detailText = (t.detail || '{liter} Liter im Jahr. {kartuschen} Kartuschen pro Jahr zu je {kpreis}{abo}.')
          .replace('{liter}', zahl(literJahr)).replace('{kartuschen}', zahl(kartuschenJahr, 1)).replace('{kpreis}', euroCent(kPreis))
          .replace('{abo}', aboText);
      }
      var zeile = function (label, a, b) {
        return '<tr><th scope="row">' + esc(label) + '</th><td>' + a + '</td><td>' + b + '</td></tr>';
      };
      this.ergebnis.innerHTML =
        '<p class="alb-kr-fazit">' + fazit + '</p>' +
        '<div class="alb-kr-tabelle-wrap"><table class="alb-kr-tabelle">' +
          '<thead><tr><th></th><th scope="col">' + esc(t.sp_flasche || 'Flaschenwasser') + '</th><th scope="col">' + esc(f.titel) + '</th></tr></thead><tbody>' +
          zeile(t.z_jahr1 || 'Im ersten Jahr', euro(flaschenJahr), euro(jahr1)) +
          zeile(t.z_ab2 || 'Jedes weitere Jahr', euro(flaschenJahr), euro(abJahr2)) +
          zeile(t.z_fuenf || 'Fünf Jahre gesamt', euro(flaschenFuenf), euro(fuenf)) +
          zeile(t.z_liter || 'Je Liter', euroCent(preisL), euroCent(literpreisFilter)) +
          zeile(t.z_kilo || 'Getragene Kilo im Jahr', zahl(kiloJahr) + '&nbsp;kg', '0&nbsp;kg') +
        '</tbody></table></div>' +
        '<p class="alb-kr-detail">' + esc(detailText) + '</p>' +
        (f.url ? '<a class="alb-btn alb-kr-btn" href="' + esc(f.url) + '">' + esc((t.btn_filter || 'Zum {filter}').replace('{filter}', f.titel)) + '</a>' : '');
      this.zaehle(personen, preisL, f.handle, diffFuenf > 0);
    }

    zaehle(personen, preisL, handle, filterGuenstiger) {
      if (gezaehlt) return;                       // ein Ereignis je Seitenaufruf reicht (erste Berechnung)
      gezaehlt = true;
      warteschlange.push({ personen: personen, preisstufe: preisL <= 0.2 ? 'discounter' : (preisL <= 0.3 ? 'durchschnitt' : (preisL <= 0.6 ? 'marke' : 'premium')), filter: handle, filter_guenstiger: filterGuenstiger ? 'ja' : 'nein' });
      if (einwilligungAngefragt) {
        if (einwilligungErteilt) while (warteschlange.length) albGa4('alb_kostenrechner', warteschlange.shift());
        return;
      }
      einwilligungAngefragt = true;
      mitAnalyseEinwilligung(function () {
        einwilligungErteilt = true;
        while (warteschlange.length) albGa4('alb_kostenrechner', warteschlange.shift());
      });
    }
  }

  customElements.define('alb-kostenrechner', AlbKostenrechner);
})();
